var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"m-oa-info"},[_c('div',{staticClass:"header"},[_c('p',{staticClass:"r"},[_vm._v(_vm._s(_vm.userData.name)+"，"),_c('a',{staticClass:"signOut",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.signOut()}}},[_vm._v("退出")])]),_vm._v(" "),_c('div',{staticClass:"logo"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76241594","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MHeader.vue
// module id = null
// module chunks = 